import React, { useState } from 'react';
import { Select, Menu, MenuItem } from '@mui/material';
import { BsPlusLg as Plus } from 'react-icons/bs';
import { IoChevronDownOutline as DropDownArrow } from 'react-icons/io5';
import TeamBox from '@ManagementRepresentationalDisplay/TeamBox';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import './TeamsList.scss';

export default function TeamsList(props) {

    const [showDropDown,setShowDropDown]= useState(false);
    const [anchorDropDown,setAnchorDropDown] =useState(false);
    const activeUserId = localStorage.getItem('activeUserId');
    let currentOrg = localStorage.getItem('currentOrg');
    let currentOrgId = localStorage.getItem('currentOrgId');
    const currentUserOrgPermissions = JSON.parse(localStorage.activeUserPermissions).orgs[currentOrgId];
    const className= 'organization__TeamsList';

    const toggleClick = (event) => {
        setShowDropDown(!showDropDown);
        if(!!event) {
            setAnchorDropDown(event.currentTarget);
        }else {
            setAnchorDropDown(null);
        }
    }

    const handleDropDownPopup = (event) => {
        if(!showDropDown){
            if(!!event) {
                setAnchorDropDown(event.currentTarget);
                setShowDropDown(true);
            }
        } else {
            setAnchorDropDown(null);
            setShowDropDown(false);
        }
    }

    const closeThePopUp = () =>{
        setShowDropDown(!showDropDown)
    }

    return(
        <div className={className + ' component-shadow flex-row-center-space-between width-wfa'}>
            <Select
                value={props.selectedTeamIndex}
                onChange={(e) => props.handleTeamTabClick(e, e.target.value)}
                displayEmpty
                className={className + '__teamsSelect width-wfa'}
                renderValue={(selected) => {
                    if (props.teams.length === 0) {
                        return "You are not a part of any Team.";
                    }
                    return props.teams[selected]?.name || "Teams";
                }}>
                {
                    props.teams.length !== 0 ? (
                        props.teams.map((team, i) => (
                            <MenuItem key={i} value={i} className={className + '__menu__menuItem'}>
                                <TeamBox team={team} />
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled className={className + '__noTeam'}>
                            You are not a part of any Team.
                        </MenuItem>
                    )
                }
            </Select>
        </div>
    );
}